/* src/app/loading/loading.component.scss */
.teal {
  color: #8accbf;
}
/*# sourceMappingURL=/loading.component.css.map */
